var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessFp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 66C0 102.394 29.6061 132 66 132C102.394 132 132 102.394 132 66C132 29.6061 102.394 0 66 0C29.6061 0 0 29.6061 0 66ZM8.25 66C8.25 34.1551 34.1551 8.25 66 8.25C97.8449 8.25 123.75 34.1551 123.75 66C123.75 97.8449 97.8449 123.75 66 123.75C34.1551 123.75 8.25 97.8449 8.25 66ZM56.8966 86.7902C57.7003 87.5989 58.7557 87.9997 59.8121 87.9997C60.8686 87.9997 61.924 87.5989 62.7377 86.7902L98.488 51.0399C100.099 49.4285 100.099 46.8162 98.488 45.2048C96.8767 43.5935 94.2643 43.5935 92.653 45.2048L60.5243 77.3326C60.1338 77.7231 59.5006 77.7231 59.1101 77.3325L44.858 63.0795C43.2457 61.4682 40.6333 61.4682 39.022 63.0795C37.4106 64.6908 37.4106 67.3032 39.022 68.9155L56.8966 86.7902Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -35.1527,
    y1: 21.7691,
    x2: 24.4633,
    y2: 164.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    stopColor: "#FEDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    stopColor: "#FEC809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    stopColor: "#FF9022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessFp);
export default __webpack_public_path__ + "static/media/successFP.bf5eda7112dd99cac300e99347aa977d.svg";
export { ForwardRef as ReactComponent };